import {
  AccordionDetails,
  AccordionSummary,
  Box,
  styled,
  Typography,
} from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

import theme from 'src/style-system/theme';
import Accordion from '@components/Accordian';
import { faqContentType } from '@utils/types';
import { PrismicRichText } from '@prismicio/react';
import { useStyles } from './useStyles';

interface FaqSectionProps {
  faqContent: any;
}

const FaqSection = ({ faqContent }: FaqSectionProps) => {
  const { slices } = faqContent?.data || {};
  const [{ items }] = slices || [{}];

  const classes = useStyles();

  if (!faqContent?.data) {
    return null;
  }

  const handleChange = (
    _event: React.SyntheticEvent,
    expanded: boolean,
    question: string
  ) => {
    //@ts-ignore
    window?.dataLayer.push({
      text: question,
      event: expanded ? 'faq_open' : 'faq_close',
    });
  };

  return (
    <Box
      sx={{
        maxWidth: '90vw',
        marginBottom: '25px',
        [theme.breakpoints.up('md')]: {
          maxWidth: '80vw',
          marginBottom: '70px',
        },
        [theme.breakpoints.up('lg')]: {
          maxWidth: '1100px',
        },
      }}
    >
      <Typography variant="h1" align="center" color="cinnamon.main">
        FAQs
      </Typography>
      <Box
        sx={{
          margin: '30px 0',
          [theme.breakpoints.up('lg')]: {
            margin: '50px 0 40px',
          },
        }}
      >
        {items?.map((item: any) => (
          <Accordion
            bgcolor={theme.palette.whitePepper.main}
            bordercolor={theme.palette.cumin.main}
            key={item.key}
            onChange={(event: React.SyntheticEvent, expanded: boolean) =>
              handleChange(event, expanded, item?.question)
            }
          >
            <AccordionSummary
              expandIcon={
                <ArrowDropDownIcon
                  fontSize="large"
                  sx={{ color: 'garamMasala.main' }}
                />
              }
              aria-controls="panel1a-content"
              sx={{ marginTop: '10px', marginBottom: '10px' }}
            >
              <Typography variant="body1" align="left" color="cinnamon.main">
                {item?.question || ''}
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ padding: '0px 16px 8px' }}>
              <Box>
                <PrismicRichText
                  field={item?.answer}
                  components={{
                    paragraph: ({ children }) => (
                      <Typography
                        variant="body2"
                        align="justify"
                        color="cumin.main"
                      >
                        {children}
                      </Typography>
                    ),
                    oList: ({ children }) => {
                      return (
                        <ol className={classes.unorderedlist}>
                          <Typography
                            variant="body2"
                            align="justify"
                            color="cumin.main"
                          >
                            {children}
                          </Typography>
                        </ol>
                      );
                    },
                    list: ({ children }) => {
                      return (
                        <ul className={classes.unorderedlist}>
                          <Typography
                            variant="body2"
                            align="justify"
                            color="cumin.main"
                          >
                            {children}
                          </Typography>
                        </ul>
                      );
                    },

                    preformatted: ({ children }) => {
                      return (
                        <Typography
                          variant="body2"
                          align="justify"
                          color="cumin.main"
                        >
                          {children}
                        </Typography>
                      );
                    },
                  }}
                />
              </Box>
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>
    </Box>
  );
};

export default FaqSection;
